<div
  class="full-page"
  [style.background-image]="'url(' + ('login-registration/rewards-background.jpg' | contentAssetImage) + ')'"
>
  <div class="container">
    <div class="w-100 text-center mt-3">
      <img class="logo mb-4" [src]="'logos/rewards-logo.png' | contentAssetImage" draggable="false" />
    </div>
    <div class="reg-background">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
